import React, { ReactElement, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "./core/authContext";
import { getToken, parseJwt } from "./core/auth";
import { routes } from "./routes/routes";
import AppRouter from "./AppRouter";
import { roleKey } from "./variables/constants";


interface ComponentMap {
  [key: string]: ReactElement;
}

const getIndexElement: ComponentMap = {
  Client: <Navigate to="/accounts" />,
  Auditor: <Navigate to="/clientStatement" />,
  Administrator: <Navigate to="/transactions/transactionHistory" />,
};

function AppWrapper() {
  const token = getToken();
  const [isLoggedIn, setIsLoggedIn] = useState(!!token);

  useEffect(() => {
    setIsLoggedIn(!!token);
  }, [token]);

  const user = token ? parseJwt(token) : {};

  return (
    <AuthContext.Provider value={{ isLoggedIn, user }}>
      <AppRouter
        isLoggedIn={isLoggedIn}
        allowedRoutes={routes(user[roleKey])}
        indexElement={getIndexElement[user[roleKey]]}
      />
    </AuthContext.Provider>
  );
}

export default AppWrapper;
